
import _hyperscript from "../lib/core.js"

import web from "../lib/web.js"

web(_hyperscript)

export default _hyperscript
